import React, { useState, useEffect } from "react";
import { Empty, Table } from "antd";
import moment from "moment";
import RequestHandler from "../../util/RequestHandler";

const SubscriberUserHistory = (props) => {
  const [tenantSubscriberUsers, setTenantSubscriberUsers] = useState({
    data: [],
    total: 0,
    loading: true,
  });
  const [homeOwnersUsers, setHomeOwnerUsers] = useState({
    data: [],
  });
  const [hirerUsers, setHirerUsers] = useState({
    data: [],
  });
  const [firmId, setFirmId] = useState(props.firmId.toUpperCase());

  useEffect(() => {
    setTenantSubscriberUsers({
      ...tenantSubscriberUsers,
      loading: true,
    });

    RequestHandler.get(`/SubscriberFirm/GetById/${firmId}`).then((response) => {
      setTenantSubscriberUsers({
        data: response[0].tenantSubscriberUsersVm,
        total: response["@odata.count"],
        loading: false,
      });
      setHomeOwnerUsers({
        data: response[0].tenantSubscriberUsersVm.filter(
          (item) => item.isHirer === false
        ),
      });
      setHirerUsers({
        data: response[0].tenantSubscriberUsersVm.filter(
          (item) => item.isHirer === true
        ),
      });
    });
  }, [setFirmId]);

  const dataStateChange = (e) => {
    setTenantSubscriberUsers(e);
  };

  const homeOwnersTableColumns = [
    {
      title: "Ev Sahibi Bilgileri",
      dataIndex: "",
      key: "names",
      align: "left",
      render: (data) => {
        return data != Empty ? data.subscriberUserVm.name : "";
      },
    },
    {
      title: "",
      dataIndex: "",
      key: "Datetimes",
      align: "left",
      render: (data) =>
        moment(data.addDate).format("DD.MM.YYYY") +
        " - " +
        (data.updateDate != null
          ? moment(data.updateDate).format("DD.MM.YYYY")
          : ""),
    },
  ];

  const hirerTableColumns = [
    {
      title: "Kiracı Bilgileri",
      dataIndex: "",
      key: "names",
      align: "left",
      render: (data) => {
        return data != Empty ? data.subscriberUserVm.name : "";
      },
    },
    {
      title: "",
      dataIndex: "",
      key: "Datetimes",
      align: "left",
      render: (data) =>
        moment(data.addDate).format("DD.MM.YYYY") +
        " - " +
        (data.updateDate != null
          ? moment(data.updateDate).format("DD.MM.YYYY")
          : ""),
    },
  ];

  return (
    <div
      className="container"
      style={{ display: "flex", flexDirection: "row", width: "max-content" }}
    >
      <div className="row" style={{ width: "max-content" }}>
        <div className="col">
          <Table
            locale={{
              emptyText: (
                <Empty
                  image={Empty.PRESENTED_IMAGE_SIMPLE}
                  description="Veri Yok"
                />
              ),
            }}
            columns={homeOwnersTableColumns}
            dataSource={homeOwnersUsers.data}
            onDataStateChange={dataStateChange}
            loading={tenantSubscriberUsers.loading}
            pagination={false}
            sortable={true}
            rowKey="id"
            size="small"
            bordered={false}
            showHeader={true}
          ></Table>
        </div>
      </div>
      {hirerUsers.data.length != 0 && (
        <div className="row">
          <div className="col">
            <Table
              locale={{
                emptyText: (
                  <Empty
                    image={Empty.PRESENTED_IMAGE_SIMPLE}
                    description="Veri Yok"
                  />
                ),
              }}
              columns={hirerTableColumns}
              dataSource={hirerUsers.data}
              onDataStateChange={dataStateChange}
              loading={tenantSubscriberUsers.loading}
              pagination={false}
              sortable={true}
              rowKey="id"
              size="small"
              bordered={false}
              showHeader={true}
            ></Table>
          </div>
        </div>
      )}
    </div>
  );
};
export default SubscriberUserHistory;
